module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_library.js
// module id = 49
// module chunks = 14